import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { getAbsoluteUrl } from "shared/lib/utils";

import type { articleSourceHeaderArticle$key } from "scmp-app/queries/__generated__/articleSourceHeaderArticle.graphql";

import { Container, Source, SourceText, StyledEntityLink, StyledScmpLogoFlag } from "./styles";

type Props = {
  className?: string;
  reference: articleSourceHeaderArticle$key;
};

export const ArticleSourceHeader: FunctionComponent<Props> = ({ className, reference }) => {
  const article = useFragment<articleSourceHeaderArticle$key>(
    graphql`
      fragment articleSourceHeaderArticle on Article {
        urlAlias
        ...entityLink
      }
    `,
    reference,
  );

  return (
    <Container className={className}>
      <StyledScmpLogoFlag />
      <Source>
        <SourceText>Source:</SourceText>
        <StyledEntityLink reference={article}>{getAbsoluteUrl(article?.urlAlias)}</StyledEntityLink>
      </Source>
    </Container>
  );
};

ArticleSourceHeader.displayName = "ArticleSourceHeader";
